module.exports = __webpack_public_path__ + "static/media/image8.33b68e9b.png";